var compEstatisticas = Vue.component('estatisticas', {

    template: '#estatisticas-comp',
    parent: compQuestao,
    ready: function(){
        this.questaoId = this.$parent.id;
        var self = this;
        ajaxGET(
            '/questao/estatisticas',
            { questaoId: this.questaoId },
            self.carregaEstatisticas
        );
    },
    data: function () {
        return {
            dadosSuficientes    : false,
            questaoId           : -1,
            dadosDesempenho   : {
                labels: [
                    "Acerto",
                    "Erro"
                ],
                datasets: [{
                        data: [ ],
                        backgroundColor: [
                            "rgba(25, 196, 9, 1)",
                            "rgba(234, 9, 13, 1)"
                        ],
                        hoverBackgroundColor: [
                            "rgba(25, 196, 9, 0.8)",
                            "rgba(234, 9, 13, 0.8)"
                        ]
                }]
            },
            dadosObjetivas   : {
                labels: [ "(A)", "(B)", "(C)", "(D)", "(E)" ],
                datasets: [{
                    data: [],
                    backgroundColor: [
                        "rgba(51, 153, 255, 1)",
                        "rgba(255, 255, 0, 1)",
                        "rgba(179, 0, 134, 1)",
                        "rgba(153, 102, 51, 1)",
                        "rgba(255, 102, 0, 1)"
                    ],
                    hoverBackgroundColor: [
                        "rgba(51, 153, 255, 0.8)",
                        "rgba(255, 255, 0, 0.8)",
                        "rgba(179, 0, 134, 0.8)",
                        "rgba(153, 102, 51, 0.8)",
                        "rgba(255, 102, 0, 0.8)"
                    ]
                }]
            },
            dadosCE : {
                labels: [ "(c)", "(e)" ],
                datasets: [{
                    data: [],
                    backgroundColor: [
                        "rgba(179, 0, 134, 1)",
                        "rgba(255, 102, 0, 1)"
                    ],
                    hoverBackgroundColor: [
                        "rgba(179, 0, 134, 0.8)",
                        "rgba(255, 102, 0, 0.8)"
                    ]
                }]
            }
        }
    },
    methods: {
        carregaEstatisticas: function (dados) {
            var self = this;
            // var lala = dados;

            /* Dados insuficientes pra gráfico? Mostrar mensagem só */
            if( dados.hasOwnProperty('dadosInsuficientes') ){
                this.dadosSuficientes = false;
                this.$parent.carregando.estatisticas = false;
                return;
            }

            this.dadosSuficientes = true;
            this.$parent.carregando.estatisticas = false;

            Vue.nextTick(function () {

                self.graficoDesempenho(dados);

                if( self.$parent.tipo == 'objetiva' ){
                    self.graficoObjetivas(dados);
                }

                if( self.$parent.tipo == 'ce' ){
                    self.graficoCE(dados);
                }
            });

        },
        graficoDesempenho: function (dados) {

            var self = this;
            this.dadosDesempenho.datasets[0].data = [dados.desempenho.acertaram, dados.desempenho.erraram];
            var ctxDesemp = $('#grafico-desempenho-'  + this.questaoId);

            var grafDesemp = new Chart(ctxDesemp, {
                type: 'doughnut',
                data: self.dadosDesempenho,
                options: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            boxWidth: 20
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return data.datasets[0].data[tooltipItem.index] + '% de ' + data.labels[tooltipItem.index];
                            }
                        }
                    }
                }
            });
        },
        graficoObjetivas: function (dados) {

            var self = this;

            this.dadosObjetivas.datasets[0].data = [
                dados.alternativas.a, dados.alternativas.b,
                dados.alternativas.c, dados.alternativas.d, dados.alternativas.e
            ];

            var ctxAlt = $('#grafico-objetiva-' + this.questaoId);

            var grafAlt = new Chart(ctxAlt, {
                type: 'doughnut',
                data: self.dadosObjetivas,
                options: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            boxWidth: 20
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return data.datasets[0].data[tooltipItem.index] +
                                    '% responderam ' + data.labels[tooltipItem.index];
                            }
                        }
                    }
                }
            });
        },
        graficoCE: function (dados) {

            var self = this;

            this.dadosCE.datasets[0].data = [ dados.alternativas.c, dados.alternativas.e ];

            var ctxCE = $('#grafico-ce-' + this.questaoId);

            var grafCE = new Chart(ctxCE, {
                type: 'doughnut',
                data: self.dadosCE,
                options: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            boxWidth: 20
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return data.datasets[0].data[tooltipItem.index] +
                                    '% responderam ' + data.labels[tooltipItem.index];
                            }
                        }
                    }
                }
            });
        }
    }
});